/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Tax_Mtt_UnknownInputs */

const vi_einvoice_tax_mtt_unknown = /** @type {(inputs: Einvoice_Tax_Mtt_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa xác nhận trạng thái tiếp nhận của CQT`)
};

/**

* @param {Einvoice_Tax_Mtt_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_tax_mtt_unknown = /** @type {((inputs?: Einvoice_Tax_Mtt_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Tax_Mtt_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_tax_mtt_unknown(inputs)
});